import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import PublicNav from '../components/dna/PublicNav';
import Footer from '../components/dna/Footer';

export default function ContactPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
  const [sent, setSent] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    // Simulation — à connecter à un vrai backend plus tard
    setSent(true);
  };

  return (
    <div className="site-shell legal-page"><PublicNav /><div className="passio-terms-page">
      <header className="passio-terms-header">
        <div className="passio-terms-header-inner">
          <Link to="/" className="passio-terms-logo">
            <img src="/assets/Logo.png" alt="Pass'io" />
          </Link>
          <nav className="passio-terms-nav">
            <Link to="/" className="passio-terms-back">
              <i className="fas fa-arrow-left" /> Retour à l'accueil
            </Link>
          </nav>
        </div>
      </header>

      <div style={{
        maxWidth: '900px',
        margin: '0 auto',
        padding: '5rem 1.5rem 2rem',
      }}>
        <main className="passio-terms-content">
          <div className="passio-terms-hero">
            <span className="passio-terms-badge">Contact</span>
            <h1 className="passio-terms-title">Contactez-nous</h1>
            <p className="passio-terms-meta">
              Une question, un problème ou une suggestion ? Nous sommes là pour vous aider.
            </p>
          </div>

          {/* Coordonnées rapides */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
            gap: '1rem',
            marginBottom: '2.5rem',
          }}>
            {[
              { icon: 'fa-envelope', title: 'Email', desc: 'contact@passio.mg', link: 'mailto:contact@passio.mg' },
              { icon: 'fa-telegram', title: 'Telegram', desc: '@PassioArtistBot', link: 'https://t.me/PassioArtistBot' },
              { icon: 'fa-location-dot', title: 'Adresse', desc: 'Antananarivo, Madagascar' },
              { icon: 'fa-clock', title: 'Délai réponse', desc: 'Sous 24 à 48h' },
            ].map((item, i) => (
              <div key={i} style={{
                background: 'var(--bg-cream, #fdf0d5)',
                borderRadius: '14px',
                padding: '1.25rem',
                textAlign: 'center',
              }}>
                <div style={{
                  width: '40px', height: '40px', borderRadius: '12px',
                  background: '#780000', color: '#fff',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  margin: '0 auto 0.75rem', fontSize: '1rem',
                }}>
                  <i className={`fas ${item.icon}`} />
                </div>
                <div style={{ fontWeight: 700, fontSize: '0.85rem', color: '#1a1a2e' }}>{item.title}</div>
                {item.link ? (
                  <a href={item.link} target="_blank" rel="noreferrer"
                    style={{ fontSize: '0.8rem', color: '#780000', textDecoration: 'none', fontWeight: 600 }}>
                    {item.desc}
                  </a>
                ) : (
                  <div style={{ fontSize: '0.8rem', color: '#6c757d' }}>{item.desc}</div>
                )}
              </div>
            ))}
          </div>

          {/* Formulaire de contact */}
          <div style={{
            background: 'var(--surface, #fff)',
            borderRadius: '16px',
            border: '1px solid rgba(0,0,0,0.07)',
            padding: '2rem',
          }}>
            <h3 style={{ fontWeight: 700, fontSize: '1.1rem', color: '#1a1a2e', marginBottom: '1.5rem' }}>
              Envoyez-nous un message
            </h3>

            {sent ? (
              <div style={{
                textAlign: 'center', padding: '3rem 1rem',
              }}>
                <div style={{
                  width: '64px', height: '64px', borderRadius: '50%',
                  background: 'rgba(22,163,74,0.1)', color: '#16a34a',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  margin: '0 auto 1rem', fontSize: '1.5rem',
                }}>
                  <i className="fas fa-check" />
                </div>
                <h4 style={{ fontWeight: 700, color: '#1a1a2e', marginBottom: '0.5rem' }}>
                  Message envoyé !
                </h4>
                <p style={{ fontSize: '0.9rem', color: '#6c757d', marginBottom: '1.5rem' }}>
                  Nous vous répondrons dans les plus brefs délais.
                </p>
                <button onClick={() => setSent(false)}
                  className="btn btn-outline-secondary btn-sm rounded-pill px-4">
                  Envoyer un autre message
                </button>
              </div>
            ) : (
              <form onSubmit={handleSubmit}>
                <div className="row g-3">
                  <div className="col-md-6">
                    <label className="form-label" style={{ fontSize: '0.85rem', fontWeight: 600, color: '#1a1a2e' }}>
                      Nom complet
                    </label>
                    <input
                      type="text" className="form-control" required
                      placeholder="Votre nom"
                      value={form.name}
                      onChange={(e) => setForm({ ...form, name: e.target.value })}
                      style={{ borderRadius: '10px', fontSize: '0.9rem', padding: '0.65rem 1rem' }}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label" style={{ fontSize: '0.85rem', fontWeight: 600, color: '#1a1a2e' }}>
                      Email
                    </label>
                    <input
                      type="email" className="form-control" required
                      placeholder="votre@email.com"
                      value={form.email}
                      onChange={(e) => setForm({ ...form, email: e.target.value })}
                      style={{ borderRadius: '10px', fontSize: '0.9rem', padding: '0.65rem 1rem' }}
                    />
                  </div>
                  <div className="col-12">
                    <label className="form-label" style={{ fontSize: '0.85rem', fontWeight: 600, color: '#1a1a2e' }}>
                      Sujet
                    </label>
                    <select
                      className="form-select" required
                      value={form.subject}
                      onChange={(e) => setForm({ ...form, subject: e.target.value })}
                      style={{ borderRadius: '10px', fontSize: '0.9rem', padding: '0.65rem 1rem' }}
                    >
                      <option value="">Sélectionnez un sujet</option>
                      <option value="support">Support technique</option>
                      <option value="paiement">Question sur un paiement</option>
                      <option value="premium">Abonnement Premium</option>
                      <option value="partenariat">Partenariat / Collaboration</option>
                      <option value="bug">Signaler un bug</option>
                      <option value="autre">Autre</option>
                    </select>
                  </div>
                  <div className="col-12">
                    <label className="form-label" style={{ fontSize: '0.85rem', fontWeight: 600, color: '#1a1a2e' }}>
                      Message
                    </label>
                    <textarea
                      className="form-control" rows="5" required
                      placeholder="Décrivez votre demande en quelques mots..."
                      value={form.message}
                      onChange={(e) => setForm({ ...form, message: e.target.value })}
                      style={{ borderRadius: '10px', fontSize: '0.9rem', padding: '0.65rem 1rem', resize: 'vertical' }}
                    />
                  </div>
                </div>
                <div className="mt-3 text-end">
                  <button type="submit" className="btn px-4 fw-semibold rounded-pill"
                    style={{ background: '#780000', color: '#fff', border: 'none', padding: '0.65rem 2rem' }}>
                    <i className="fas fa-paper-plane me-2" />
                    Envoyer le message
                  </button>
                </div>
              </form>
            )}
          </div>

          {/* Liens utiles */}
          <div style={{
            marginTop: '2rem',
            padding: '1.5rem',
            borderRadius: '14px',
            background: 'rgba(120,0,0,0.04)',
            border: '1px solid rgba(120,0,0,0.1)',
            textAlign: 'center',
          }}>
            <p style={{ fontSize: '0.85rem', color: '#6c757d', marginBottom: '0.75rem' }}>
              Consultez aussi nos pages d'aide :
            </p>
            <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'center', flexWrap: 'wrap' }}>
              <Link to="/terms" className="btn btn-outline-danger btn-sm rounded-pill px-3 fw-semibold">
                <i className="fas fa-file-contract me-1" /> CGU
              </Link>
              <Link to="/privacy" className="btn btn-outline-danger btn-sm rounded-pill px-3 fw-semibold">
                <i className="fas fa-shield-halved me-1" /> Confidentialité
              </Link>
              <Link to="/legal" className="btn btn-outline-danger btn-sm rounded-pill px-3 fw-semibold">
                <i className="fas fa-gavel me-1" /> Mentions Légales
              </Link>
            </div>
          </div>

          <footer className="passio-terms-footer">
            <p>Pass'io — Contact — Antananarivo, Madagascar</p>
            <p><a href="mailto:contact@passio.mg">contact@passio.mg</a></p>
          </footer>
        </main>
      </div>
      </div>
      <Footer />
    </div>
  );
}
